import { NumberField, NumberFieldProps } from './number-field';
import { FieldValues, Path } from 'react-hook-form';

export interface MileageFieldProps<T extends FieldValues = FieldValues> extends Omit<NumberFieldProps<T>, 'name'> {
  name?: Path<T>;
}

export const MileageField = <T extends FieldValues = FieldValues>({
  label = 'Mileage',
  required,
  name = 'mileage' as Path<T>,
  ...rest
}: MileageFieldProps<T>) => {
  return <NumberField name={name} label={label} required={required} {...rest} />;
};
